import { motion } from 'framer-motion';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/ThankYou.css';

function ThankYou() {
  const navigate = useNavigate();
  const { mode } = useParams();

  return (
    <div className="thank-you-page">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, type: 'spring' }}
        className="thank-you-content"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
          className="success-icon-large"
        >
          ✓
        </motion.div>
        
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          Thank You!
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="message"
        >
          {`Your ${mode[0].toUpperCase() + mode.slice(1)} has been successfully submitted.`}
        </motion.p>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="sub-message"
        >
          We'll be in touch with the details soon. Thank you for helping us grow!
        </motion.p>
      { mode !== 'form-submission' && (
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7 }}
          className="home-button"
          onClick={() => navigate('/')}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {`Submit Another ${mode[0].toUpperCase() + mode.slice(1)}`}
        </motion.button>
      )}
      </motion.div>
    </div>
  );
}

export default ThankYou;
